<template>
  <section class="is-card">
    <h2 class="is-bolder font-lg">
      Produtos
    </h2>
    <div
      v-for="(item, key) in productsShortcut"
      :key="key"
      class="product-box"
    >
      <template v-if="item && key === 0 || showShortcuts">
        <p class="is-bold font-md">
          {{ item.label }}

          <span
            v-if="productsShortcut.length > 1"
            @click="togglePriority(item.label)"
          >
            <PinSVG
              :is-pinned="item.isPriority"
            />
          </span>
        </p>

        <div>
          <a
            :href="item.routes[0].url"
            class="button"
          >
            <i
              :class="item.routes[0].icon"
            />
            Consultar
          </a>
          <a
            :href="item.routes[1].url"
            class="button"
          >
            <i
              :class="item.routes[1].icon"
            />
            Propostas
          </a>
          <a
            v-if="item.routes[2]"
            :href="item.routes[2].url"
            class="button"
          >
            <i
              :class="item.routes[2].icon"
            />
            {{ item.routes[2].label }}
          </a>
        </div>
      </template>
    </div>
    <BtnShowAll
      v-if="productsShortcut.length > 1"
      v-model="showShortcuts"
      :label="{
        true: 'Exibir menos',
        false: 'Exibir mais',
      }"
    />
  </section>
</template>
<script>
import PinSVG from '@/assets/icons/Pin.vue';
import BtnShowAll from '@/components/Base/BtnShowAll/index.vue';

export default {
  name: 'ShortcutSection',
  components: {
    BtnShowAll,
    PinSVG,
  },
  data() {
    return {
      showShortcuts: false,
      productsShortcut: [],
    };
  },
  mounted() {
    this.getQuickAccessMenu();
    this.checkPriorityOnSession();
  },
  methods: {
    // handlers
    togglePriority(label) {
      sessionStorage.setItem('hubPriority', label);
      this.checkPriorityOnSession();
    },
    checkPriorityOnSession() {
      const priority = sessionStorage.getItem('hubPriority');

      this.productsShortcut.forEach((elem) => {
        if ((priority && elem.label === priority)
            || (priority === undefined && elem.label === 'FGTS')) {
          elem.isPriority = true;
          sessionStorage.setItem('hubPriority', elem.label);
        } else {
          elem.isPriority = false;
        }
      });

      this.reorderPriority();
    },
    reorderPriority() {
      const prorityItem = this.productsShortcut.findIndex((elem) => elem.isPriority === true);
      const [removedItem] = this.productsShortcut.splice(prorityItem, 1);

      this.productsShortcut.unshift(removedItem);
    },
    getQuickAccessMenu() {
      const quickAccessMenu = JSON.parse(localStorage.getItem('quick_access'));
      this.productsShortcut = quickAccessMenu?.map((elem) => (
        {
          ...elem,
          isPriority: elem.label === 'FGTS',
        }
      ));
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';
@import '@/assets/scss/src/_buttonsVariables.scss';

.product-box {
  gap: 16px;
  display: flex;
  flex-wrap: wrap;

  div {
    display: flex;
    gap: 16px;

    @media screen and (max-width: 400px) {
      gap: 8px;
      overflow: overlay;

      .button {
        padding: 8px 12px;
      }
    }
  }

  p {
    min-width: 100%;
    margin-top: 21px;

    span {
      float: right;
    }
  }
  .button {
    min-height: 90px;
    flex-direction: column;
    gap: 8px;

    svg, i {
      color: #4754BB;
      stroke: none;
      padding: 7px;
      width: 28px;
      height: 28px;
      border-radius: 8px;
      background-color: $slate-100;
    }
    font-size: 12px;
  }
}

.divider-expand {
  margin-top: 31px;
}

</style>
